import Firebase from 'firebase'
const firebaseApp = Firebase.initializeApp({
  apiKey: 'AIzaSyAWdzEQdR4jM_wEfz9xzf_fak3kE9dtESU',
  authDomain: 'takeitmakeit-b7ef1.firebaseapp.com',
  databaseURL: 'https://takeitmakeit-b7ef1.firebaseio.com',
  projectId: 'takeitmakeit-b7ef1',
  storageBucket: 'takeitmakeit-b7ef1.appspot.com',
  messagingSenderId: '768082669515'
})

export default firebaseApp



// WEBPACK FOOTER //
// ./src/classes/Db.js